import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/case/view/$id/case-info")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
